let activeRequests = 0;
const listeners = new Set();
let hideTimer = null;

const notify = () => {
  const isLoading = activeRequests > 0;
  listeners.forEach((listener) => listener(isLoading, activeRequests));
};

export const loadingService = {
  start() {
    if (hideTimer) {
      clearTimeout(hideTimer);
      hideTimer = null;
    }
    activeRequests += 1;
    notify();
  },

  stop() {
    activeRequests = Math.max(0, activeRequests - 1);
    if (activeRequests === 0) {
      hideTimer = setTimeout(() => {
        notify();
      }, 180);
      return;
    }
    notify();
  },

  subscribe(listener) {
    listeners.add(listener);
    listener(activeRequests > 0, activeRequests);
    return () => listeners.delete(listener);
  },
};
